export default __webpack_public_path__ + "static/media/wave-second.1872869a.svg";